"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.firebase = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

// @TODO: Firebase doesn't export a list of providerIds they use
// But I found them here: https://github.com/firebase/firebase-js-sdk/blob/a5768b0aa7d7ce732279931aa436e988c9f36487/packages/rules-unit-testing/src/api/index.ts
// NOTE: 2021-09-15 firebase now exports a const/enum ProviderId which could perhabps be used in place of this
const hasPasswordCreds = options => {
  return options.email !== undefined && options.password !== undefined;
};

const applyProviderOptions = (provider, options) => {
  if (options.customParameters) {
    provider.setCustomParameters(options.customParameters);
  }

  if (options.scopes) {
    var _context;

    (0, _forEach.default)(_context = options.scopes).call(_context, scope => provider.addScope(scope));
  }

  return provider;
};

const firebase = ({
  firebaseAuth,
  firebaseApp
}) => {
  const auth = firebaseAuth.getAuth(firebaseApp);

  function getProvider(providerId) {
    return new firebaseAuth.OAuthProvider(providerId);
  }

  const loginWithEmailLink = ({
    email,
    emailLink
  }) => {
    if (email !== undefined && emailLink !== undefined && firebaseAuth.isSignInWithEmailLink(auth, emailLink)) {
      return firebaseAuth.signInWithEmailLink(auth, email, emailLink);
    }

    return undefined;
  };

  return {
    type: 'firebase',
    client: auth,
    restoreAuthState: () => {
      // return a promise that we be await'd on for first page load until firebase
      // auth has loaded, indicated by the first firing of onAuthStateChange)
      return new _promise.default((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
        }, reject);
      });
    },
    login: async (options = {
      providerId: 'google.com'
    }) => {
      // If argument provided is a string, it should be the oAuth Provider
      // Cast the provider string into the options object
      if (typeof options === 'string') {
        options = {
          providerId: options
        };
      }

      if (hasPasswordCreds(options)) {
        return firebaseAuth.signInWithEmailAndPassword(auth, options.email, options.password);
      }

      if (options.providerId === 'emailLink') {
        return loginWithEmailLink(options);
      }

      const provider = getProvider(options.providerId || 'google.com');
      const providerWithOptions = applyProviderOptions(provider, options);
      return firebaseAuth.signInWithPopup(auth, providerWithOptions);
    },
    logout: async () => auth.signOut(),
    signup: (options = {
      providerId: 'google.com'
    }) => {
      if (typeof options === 'string') {
        options = {
          providerId: options
        };
      }

      if (hasPasswordCreds(options)) {
        return firebaseAuth.createUserWithEmailAndPassword(auth, options.email, options.password);
      }

      if (options.providerId === 'emailLink') {
        return loginWithEmailLink(options);
      }

      const provider = getProvider(options.providerId || 'google.com');
      const providerWithOptions = applyProviderOptions(provider, options); // Potentially useful to support signInWithCredential without popup

      return firebaseAuth.signInWithPopup(auth, providerWithOptions);
    },
    getToken: async () => {
      return auth.currentUser ? auth.currentUser.getIdToken() : null;
    },
    getUserMetadata: async () => {
      return auth.currentUser;
    }
  };
};

exports.firebase = firebase;